import React, {PureComponent} from 'react';

import PageTemplate from '../PageTemplate/PageTemplate';
import ScriptCache from '../../utils/scriptCache';

export class Step0 extends PureComponent {
  constructor(props) {
    super(props);

    this.scriptCache = null;

    this.loadScripts = this.loadScripts.bind(this);

    this.url = process.env.REACT_APP_ENV === 'production'
    ? 'leasing.gplc.uk'
    : 'graingerstage.pexsoftware.com';

    this.PEX_CONFIG = {
      id: "grainger-booking-journey-applet",
      className: "grainger-booking-journey-applet",
      sso: `https://${this.url}/singlesign`,
      api: `https://${this.url}/json-interface`,
      vanmildert: `https://${this.url}/vanmildert`,
      enterpriselocation: `https://${this.url}`
    };
  }

  loadScripts() {
    if(!this.scriptCache) {
      this.scriptCache = new ScriptCache([
          `https://${this.url}/widgets/grainger.js`,
          `https://${this.url}/widgets/grainger-host.js`,
        ]);
    }
  }

  render() {
    const Component = (props) =>
      <div ref={this.loadScripts} {...this.PEX_CONFIG} />;

    const WrappedComponent = PageTemplate(Component);
    return <WrappedComponent {...this.props} />;
  }
}

export default Step0;



// WEBPACK FOOTER //
// ./src/components/Step0/Step0.jsx